import { getGrass, getDetailsGrass } from './action'
import { TUseRequestReturn, useRequest } from 'utils/useRequest'

export const useGrass = (): TUseRequestReturn<any> => {
  return useRequest<any>(getGrass)
}

export const useGrassById = (id: string): TUseRequestReturn<any> => {
  return useRequest<any>(getDetailsGrass, id)
}
